import { generateItemQuoteRequestModel, useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { GetCollectionDatesApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';

const useRefreshCollectionDates = () => {
  const { getCollectionDates } = useSmartSendApi();

  const refreshCollectionDates = async (items: SmartSendItemApiModel[], forceNextCollection: boolean) => {
    // Get Dates
    const collectionDateCache: { [key: string]: GetCollectionDatesApiModel[] } = {};

    for (const item of items) {
      const isCollection = item.State.validation?.QuoteState?.Quote?.Service?.CollectionType === 'Collection';
      const hasDates = item.State.validation?.QuoteState?.Dates?.length > 0;

      // An empty date list is not proof of a drop off service. A collection service can quote with
      // none, in which case this lookup is the only chance to get one before booking.
      if (!isCollection && !hasDates) {
        continue;
      }

      const collectionDateKey = generateItemQuoteRequestModel(item).collectionDateValidationKey;
      if (!collectionDateKey) {
        continue;
      }

      // Generally the collection address and service combination will be repeated.
      if (!collectionDateCache[collectionDateKey]) {
        const apiDates = await getCollectionDates(item);
        if (apiDates.success) {
          collectionDateCache[collectionDateKey] = apiDates.result.CollectionDates;
        }
      }

      // Only assign if we have some dates
      if (collectionDateCache[collectionDateKey]?.length > 0) {
        item.State.validation.QuoteState.Dates = collectionDateCache[collectionDateKey].map((d) => ({
          Date: d.CollectionDate
        }));

        // Force the first date based on configuration
        if (forceNextCollection) {
          item.PreferredCollectionDate = collectionDateCache[collectionDateKey][0].CollectionDate;
        }
      }
    }
  };

  return { RefreshCollectionDates: refreshCollectionDates };
};
export default useRefreshCollectionDates;
